import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";

const json = {
  1: {
    unit: "",
    id: "SachToan4-demo-2023-P11-E1",
    audio: "",
    video: "",
    exerciseKey: "/img/FriendsPlus/Page11/Key/E1answerKey.png",
    component: Circle_Write,
    // checkDuplicated: true,
    inputSize: 130,
    // maxLength: 1,
    stylesTextInput: {
      fontSize: "26px",
      textAlign: "center",
      background: 'transparent',
    },
    titleQuestion: [
      {
        num: "",
        title: `<div style= "display: flex">
        <div style= "background-color: rgb(61,184,187); border-radius: 50%; color: white; width: 39px; text-align: center; margin-right: 15px">1</div>
        <div style= "background-color:">Chọn câu trả lời đúng.</div>
      </div>`,
        color: "rgb(253,200,156)",
      },
    ],
    questionImage: [],
    isHiddenCheck: true,
    question: {
      Write: {
        isHiddenCheck: true,
        maxLength: 11,
        inputStyle: { width: 100, fontSize: 19, textAlign: 'center' },
        answers: [''],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: {
          padding: 0,
          borderRadius: '50%',
          fontWeight: 'bold',
          borderColor: 'transparent',
          color:'pink',
        },
        selectWordStyle: {
          padding: 5,
          border: 'solid 2px',
          // borderColor: '#00aeef',
        },
        limitSelect: 1,
        listWords: [
          `A <br> B <br> C <br> D`, //1
          `A <br> B <br> C <br> D`, //1
          `A <br> B <br> C <br> D`, //1
          `A <br> B <br> C <br> D`, //1

        ],
        answers: ['0-4', '1-12', '2-8', '3-0'],
        initialValue: [],
      },
      Layout: `
      <div style='display:flex'>
        <div style='margin-right:140px'>
            <b>a)</b>&ensp;
           		  Tổng của 53 640 và 8 290 là: <br>
            <div style="display: flex;margin-left:40px">
		          <div><input id='0' type='Circle' style='color:#ff56ff'/></div>
		          <div style='margin-left:20px'>
              61 380 <br>
              61 930 <br>
              51 930 <br>
              60 930
                    </div>
                       </div>

            <b>b)</b>&ensp;
		       Hiệu của 68 497 và 35 829 là:
            <div style="display: flex;margin-left:40px">
		          <div><input id='1' type='Circle'/></div>
                <div style='margin-left:20px'>
                31 668<br>
                32 568 <br>
                32 678 <br>
                32 668
                </div>
            </div>
      </div>
      <div >
              <b>c)</b>&ensp;
              Tích của 29 073 và 3 là:
            <div style="display: flex;margin-left:40px">
              <div><input id='2' type='Circle'/></div>
              <div style='margin-left:20px'>
              67 219<br>
              87 019 <br>
              87 219 <br>
              87 291
              </div>
            </div>
                        <b>d)</b>&ensp;
            Thực hiện phép tính 54 658 : 9 được:
              <div style="display: flex;">
            <div style="display: flex;margin-left:40px">
              <div><input id='3' type='Circle'/></div>
              <div style='margin-left:20px'>
              Thương là 6 073 và dư số là 1<br>
              Thương là 673 và dư số là 1 <br>
              Thương là 6 072 và dư số là 10 <br>
              Thương là 672 và dư số là 1
              </div>
            </div>
            </div>
      </div>
    </div>


        
      `,
    },
  },
  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-U1-P11-E2",
    audio: "",
    video: "",
    exerciseKey: "/img/FriendsPlus/Page11/Key/E2answerKey.jpg",
    component: T6,
    isEssay:true,
    textareaStyle:{width:800},
    // checkDuplicated: true,
    inputSize: 250,
    // maxLength: 1,
    stylesTextInput: {
      fontSize: "24px",
      textAlign: "left",
      background: 'transparent',
    },
    titleQuestion: [
      {
        title: `
        <div style= "background-color: rgb(61,184,187); border-radius: 50%; color: white; width: 39px; text-align: center; margin-right: 15px">2</div>
        <div style= "display: flex;
        margin-left: 50px;
        margin-top: -35px;">
        <div style= "background-color:">Ở một nhà máy sản xuất đồ chơi trẻ em, tháng Một sản xuất được 12 960 sản phẩm.
        Số sản phẩm sản xuất được sản xuất trong tháng Hai giảm đi 2 lần so với tháng Một. Hỏi tháng Hai nhà máy đó sản xuất được bao nhiêu sản phẩm.</div>
      </div>`,
        color: "rgb(253,200,156)",
      }
    ],
    questionImage: [],
    isHiddenCheck: true,
    questions: [
      {
        title: `
      <div  style='margin-top:30px' >
      <div style='margin-left:500px'><u><i><b>Bài Giải:</b></i></u></div>
        <div  style='margin-left:150px'> <textarea id='0' rows='3'></textarea></div>
          
      </div>
        `,
        answer: [],
      },
    ],
  },
  3: {
    unit: "Unit 1",
    id: "FP8-WB-demo-2023-U1-P11-E3",
    audio: "",
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page11/Key/E3answerKey.png",
    component: T6,
    textAlign: "center",
    maxLength: 9,
    inputSize: 150,
    stylesTextInput: {
      fontSize: "25px",
      textAlign: "center",
      background: 'transparent',
    },
    titleQuestion: [
      {
        title: `
        <div style= "background-color: rgb(61,184,187); border-radius: 50%; color: white; width: 39px; text-align: center; margin-right: 15px">3</div>
        <div style= "display: flex;
        margin-left: 50px;
        margin-top: -35px;">
        <div style= "background-color:">Tính giá trị của biểu thức.</div>
      </div>
				`,
        color: "rgb(120,199,215)",
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    questions: [
      {
        title: `
        <div style='line-height:2.5'>
          <div><b>a)</b> (54 000 - 6 000) : 8 = # </div>

          <div><b>b)</b> 43 680 - 7 120 x 5 = # </div>
        </div>
        `,
        answer: [
          `6000`,`8080` ,
        ],
      },
    ],
  },
  4: {
    unit: "Unit 1",
    id: "FP8-WB-demo-2023-U1-P11-E4",
    audio: "",
    video: "",
    // recorder: true,
    exerciseKey: "",
    component: T6,
    isEssay:true,
    textareaStyle:{width:800},
    textAlign: "center",
    // maxLength: 1,
    // hideBtnFooter:true,
    inputSize: 180,
    titleQuestion: [
      {
        title: `
        <div style= "background-color: rgb(61,184,187); border-radius: 50%; color: white; width: 39px; text-align: center; margin-right: 15px">4</div>
        <div style= "display: flex;
        margin-left: 50px;
        margin-top: -35px;">
        <div style= "background-color:">Để phục vụ năm học mới, một cửa hàng nhập về 4 050 quyển sách tham khảo. Số sách giáo khoa
        nhập về gấp 5 lần số sách tham khảo. Hỏi cửa hàng đó nhập về tất cả bao nhiêu quyển sách giáo khoa và sách tham khảo?</div>
      </div>
				`,
        color: "rgb(120,199,215)",
      },
    ],
    questionImage: [],
    isHiddenCheck: true,
    questions: [
      {
        title: `
        <div  style='margin-top:30px' >
        <div style='margin-left:500px'><u><i><b>Bài Giải:</b></i></u></div>
          <div  style='margin-left:150px'> <textarea id='0' rows='3'></textarea></div>
            
        </div>
        `,
        answer: [
          "",
        ],
      },
    ],
  },
};

export default json;
